<template>
  <mdb-container fluid class="gp-has-header">
    <div v-show="views.list">
      <data-table :actions="actions"
                  :force-query="forceQuery"
                  @handleAction="handleRowAction"
                  @forcedRowLoaded="forcedRowLoaded"
                  :show-add-button="userDetails.isAdmin || (userDetails.isTenantAdmin && settings.allowUserCreation)"
                  add-label="Add a New User"
                  :add-handler="addUser"
                  query-name="UserQuery"
                  page-title="System Users"
                  title-icon="users"
      />
    </div>
    <div v-if="views.user">
      <div class="text-left">
        <mdb-btn icon="arrow-left" @click="toggleView('list')">Main</mdb-btn>
        <mdb-btn icon="database" @click="$router.push('/admin/dashboard')">Admin Dashboard</mdb-btn>
        <mdb-btn icon="credit-card" @click="$router.push('/admin/billing')">Billing Dashboard</mdb-btn>
      </div>
      <mdb-card class="mb-4">
        <mdb-card-header class="primary-color">
          <div class="top-right-badge">
            <mdb-badge v-if="userDetails.isAdmin && currentUser.isAdmin" color="danger">System Administrator</mdb-badge>
            <mdb-badge v-if="currentUser.tenantAdmin" color="danger">Tenant Administrator</mdb-badge>
            <mdb-badge v-if="!currentUser.enabled && !currentUser.deleteAfter" color="danger">Banned From Platform
            </mdb-badge>
            <mdb-badge v-if="!currentUser.enabled && currentUser.deleteAfter" color="warning">Delete Pending</mdb-badge>
            <mdb-badge v-if="currentUser.apiKeys < 1" color="warning">Never Logged In</mdb-badge>
          </div>
          <img v-if="currentUser" :src="currentUser.avatar" alt="avatar" class="rounded-circle img-responsive"
               style="height:150px">
        </mdb-card-header>
        <mdb-card-body class="mb-1 text-left">
          <h3 class="mt-1 mb-2">{{ currentUser.name }}</h3>
                <mdb-dropdown tag="li" class="nav-item">
                  <mdb-dropdown-toggle tag="a" navLink slot="toggle" waves-fixed>{{ $t('page.event.actions') }}
                  </mdb-dropdown-toggle>
                  <mdb-dropdown-menu>
                    <mdb-dropdown-item @click="showHistory">
                      <mdb-icon icon="credit-card"/> Transaction History
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin"  @click="proxy">
                      <mdb-icon icon="sign-in-alt"/> Login As User
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin && !currentUser.deleteAfter"  @click="toggleDelete(currentUser)">
                      <mdb-icon icon="trash"/> Request Deletion
                    </mdb-dropdown-item>
                    <mdb-dropdown-item @click="$router.push('/conversations?start='+currentUser.id)">
                      <mdb-icon icon="envelope"/> Send Private Message
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin && !currentUser.isAdmin"  @click="toggleAdmin">
                      <mdb-icon icon="badge"/> Make System Administrator
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin && currentUser.isAdmin"  @click="toggleAdmin">
                      <mdb-icon icon="badge"/> Remove as System Administrator
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="!currentUser.tenantAdmin"  @click="toggleTenantAdmin">
                      <mdb-icon icon="badge"/> Make Tenant Administrator
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="currentUser.tenantAdmin"  @click="toggleTenantAdmin">
                      <mdb-icon icon="badge"/> Remove as Tenant Administrator
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin && currentUser.enabled"  @click="showBanModal = true">
                      <mdb-icon icon="ban"/> Ban from Platform
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin && !currentUser.enabled"  @click="unBanUser">
                      <mdb-icon icon="ban"/> Remove Platform Ban
                    </mdb-dropdown-item>
                    <mdb-dropdown-item v-if="userDetails.isAdmin"  @click="ipHistory">
                      <mdb-icon icon="bolt"/> IP Address History
                    </mdb-dropdown-item>
                  </mdb-dropdown-menu>
                </mdb-dropdown>

          <div>
            <mdb-input v-model="currentUser.id" disabled label="ID" type="text"/>
            <mdb-input v-model="currentUser.username" disabled label="Username" type="text"/>
            <mdb-input v-model="currentUser.email" disabled label="Email" type="text"/>
            <mdb-input v-model="currentUser.createDate" disabled label="Account Created" type="text"/>
            <mdb-input v-model="currentUser.freeTrialEligible" disabled
                       label="Eligible for free trial"
                       class="text-left"
                       id="freeTrialEligibleView"
                       type="checkbox"></mdb-input>

            <mdb-input v-model="currentUser.affiliateName" disabled label="Created from Affiliate" type="text"/>
            <mdb-input v-if="userDetails.isAdmin" v-model="currentUser.createdByTenant" disabled
                       label="Created from Tenant" type="text"/>

            <div v-if="currentUser.deleteAfter" class="md-form">
              <div class="text-left">
                <mdb-input v-model="currentUser.deleteAfter" disabled label="Delete After" type="text"/>
                <mdb-btn v-if="currentUser.deleteAfter" rounded size="sm"
                         icon="minus-circle"
                         @click="toggleDelete(currentUser)">Remove Delete Request
                </mdb-btn>
                <mdb-btn v-if="currentUser.deleteAfter" rounded size="sm"
                         icon="trash" color="danger"
                         @click="deleteUser(currentUser)">Delete Immediately
                </mdb-btn>
              </div>
            </div>
            <div class="text-left">
              <mdb-btn rounded size="sm" color="warning"
                       icon="pencil"
                       @click="editDetails">Edit
              </mdb-btn>
            </div>

          </div>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Other Information</h4>
        </mdb-card-header>
        <mdb-card-body>
          <custom-data :custom-data="currentUser.customData" allow-edit @dataSaved="customDataSaved"/>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4" v-if="settings.discourse && settings.discourse.enabled">
        <mdb-card-header class="secondary-color">
          <h4>Discourse Additional Groups</h4>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <div>
            <cust-chip-input :chips="currentUser.discourseGroups"/>
          </div>
          <mdb-btn icon="save" rounded size="sm" @click="saveGroups">Save</mdb-btn>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4" v-if="settings && settings.identityProvider != 'LOCAL'">
        <mdb-card-header class="secondary-color">
          <h4>Identity Provider Information</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th v-if="userDetails.isAdmin">Tenant</th>
                <th>Provider</th>
                <th>Sub/Access Token</th>
                <th>Attributes</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="login in currentUser.oauthLogins" :key="login.id">
                <td v-if="userDetails.isAdmin">{{ login.tenant }}</td>
                <td>{{ login.provider }}</td>
                <td>{{ login.accessToken }}</td>
                <td>
                  <mdb-btn v-if="login.attributes" icon="eye" size="sm" rounded @click="viewAttributes(login.attributes)">View</mdb-btn>
                  <span v-if="!login.attributes">None Provided</span>
                  <mdb-btn size="sm" rounded icon="recycle" color="success" @click="resyncIdp(login)">Sync</mdb-btn>
                </td>
                <td>
                  <mdb-btn size="sm" color="danger" icon="trash" rounded @click="deleteAuth(login)">Delete</mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Active Logins/API Access</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Key Label</th>
                <th>Authorization</th>
                <th>Date Key Created</th>
                <th>Last Accessed</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="login in currentUser.apiLogins" :key="login.id">
                <td>{{ login.label }}</td>
                <td>{{ login.authorizedRight }}</td>
                <td>{{ login. created}}</td>
                <td>{{login.lastAccessed}}</td>
                <td>
                  <mdb-btn size="sm" color="danger" icon="trash" rounded @click="deleteKey(login)">Invalidate</mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Recent Quick Connects</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Status</th>
                <th>Status Date</th>
                <th>Created IP</th>
                <th>Used IP</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="login in currentUser.quickConnects" :key="login.id">
                <td>{{ login.status }}</td>
                <td>{{ login.statusDate }}</td>
                <td>{{ login. createdIP}}</td>
                <td>{{login.usedIP}}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>




      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Subscriptions</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-btn v-if="!currentUser.currentTenantSubscription"
                   icon="plus-octagon" @click="addSubModal=true"
          >Add Subscription
          </mdb-btn>

          <mdb-tbl class="text-left" responsive striped>
            <mdb-tbl-head class="primary-color text-white">
              <tr>
                <th>Tenant</th>
                <th>Plan</th>
                <th>Last Billed</th>
                <th>Paid Through</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="sub in currentUser.subscriptions" :key="sub.id">
                <td>{{ sub.tenantName }}</td>
                <td>{{ sub.name }}<br/> {{ sub.price }} {{ sub.currency }} / {{ sub.term }}</td>
                <td>{{ sub.lastBilled }}</td>
                <td>{{ sub.paidThrough }}</td>
                <td>
                  <mdb-btn size="sm" rounded @click="manageSubscription(sub)" icon="pencil">Manage</mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Memberships</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-row>
            <div v-for="(g,i) in currentUser.groups" :key="i" class="col-md-4 align-self-stretch">
              <a href="" @click.prevent="groupAdmin(g)">
                <mdb-card class="face front mb-4">
                  <mdb-card-header class="text-right">
                    <mdb-badge>{{ g.role }}</mdb-badge>
                    <mdb-badge v-if="g.owner" color="danger">Owner</mdb-badge>
                  </mdb-card-header>
                  <mdb-view hover zoom>
                    <mdb-card-image
                      :src="g.avatar"
                      alt="Card image cap"
                    ></mdb-card-image>
                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                  </mdb-view>
                  <mdb-card-body>
                    <div class="group-name-text">
                      {{ g.name }} <br/>
                      ({{ g.tenant }})
                    </div>
                  </mdb-card-body>
                </mdb-card>
              </a>
            </div>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>

      <mdb-card v-if="currentUser.groupTracks.length>0" class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Visited Groups</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-row>
            <div v-for="(g,i) in currentUser.groupTracks" :key="i" class="col-md-4 align-self-stretch">
              <router-link :to="{ path: '/admin/group/' + g.id + '?from=user'}">
                <mdb-card class="face front mb-4">
                  <mdb-view hover zoom>
                    <mdb-card-image
                      :src="g.avatar"
                      alt="Card image cap"
                    ></mdb-card-image>
                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                  </mdb-view>
                  <mdb-card-body>
                    <div class="group-name-text">
                      {{ g.name }}
                    </div>
                  </mdb-card-body>
                </mdb-card>
              </router-link>
            </div>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>

      <mdb-card v-if="currentUser.eventTracks.length>0" class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Visited Events</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-row>
            <div v-for="(g,i) in currentUser.eventTracks" :key="i" class="col-md-4 align-self-stretch">
              <mdb-card class="face front mb-4">
                <router-link :to="{ path: '/admin/group/' + g.id + '?from=user'}">
                  <mdb-view hover zoom>
                    <mdb-card-image
                      :src="g.avatar"
                      alt="Card image cap"
                    ></mdb-card-image>
                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                  </mdb-view>
                </router-link>
                <mdb-card-body>
                  <div class="group-name-text">
                    <div>
                      <router-link :to="{path: '/event/show/' + g.eventId}">
                        {{ g.eventTitle }}
                      </router-link>
                    </div>
                    <div>
                      {{ g.name }}
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>

            </div>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>

    </div>

    <mdb-modal v-if="historyModal" size="lg" @close="historyModal=false">
      <mdb-modal-header class="secondary-color"><h4>Transaction History</h4></mdb-modal-header>
      <mdb-modal-body>
        <mdb-tbl class="text-left" responsive striped>
          <mdb-tbl-head>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Confirmation</th>
              <!--<th>&nbsp;</th> -->
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="trans in transactions" :key="trans.id">
              <td>{{ trans.date }}</td>
              <td>{{ trans.description }}</td>
              <td style="text-align: right">{{ trans.amount }}</td>
              <td>{{ trans.confirmation }}</td>
              <!--<td><mdb-btn floating size="sm" tag="a" icon="trash" color="danger" @click="deleteTransaction(trans)"/></td> -->
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>

      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="ipModal" size="lg" @close="ipModal=false">
      <mdb-modal-header class="secondary-color"><h4>IP Address History</h4></mdb-modal-header>
      <mdb-modal-body>
        <mdb-tbl class="text-left" responsive striped>
          <mdb-tbl-head>
            <tr>
              <th>IP Address</th>
              <th>Last Accessed</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(ip,i) in ipData" :key="i">
              <td>{{ ip.ipAddress }}</td>
              <td>{{ ip.lastAccessed }}</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-modal-body>
    </mdb-modal>


    <mdb-modal v-if="addUserModal" @close="addUserModal=false">
      <mdb-modal-header class="secondary-color"><h4>New User</h4></mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="newUser.name" label="Name"
                   placeholder="Name"
                   type="text"></mdb-input>
        <mdb-input v-model="newUser.email"
                   label="Email"
                   placeholder="someone@example.com" type="text"></mdb-input>
        <mdb-btn v-if="newUser.name && newUser.email" icon="save" @click="saveNewUser">Save</mdb-btn>
        <mdb-btn icon="ban" @click="addUserModal=false">Cancel</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="addSubModal" @close="addSubModal=false">
      <mdb-modal-header class="secondary-color"><h4>New Subscription</h4></mdb-modal-header>
      <mdb-modal-body>
        <gp-select :dataObj="subData" :possible-values="currentUser.availablePlans" :required="true"
                   label="Plan" propertyName="selectedPlan"/>
        <mdb-btn v-if="subData.selectedPlan" icon="save" @click="createNewSubscription">Save</mdb-btn>
        <mdb-btn icon="ban" @click="addSubModal=false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="showEditModal" @close="showEditModal=false">
      <mdb-modal-header class="secondary-color"><h4>Update Details</h4></mdb-modal-header>
      <mdb-modal-body>
        <mdb-input v-model="workingUser.email"
                   label="Email"
                   placeholder="someone@example.com" type="text"></mdb-input>
        <mdb-input v-model="workingUser.name"
                   label="Name"
                   placeholder="Name" type="text"></mdb-input>
        <mdb-input v-model="workingUser.freeTrialEligible"
                   label="Eligible for free trial"
                   id="freeTrialEligible"
                   type="checkbox"></mdb-input>

        <gp-select v-if="userDetails.isAdmin" :dataObj="workingUser" :possible-values="tenants" :required="true"
                   label="Created By Tenant" propertyName="createdByTenantId"/>

        <gp-select :dataObj="workingUser" :possible-values="affiliates" :required="true"
                   label="Created By Affiliate" propertyName="affiliateId"/>

        <mdb-btn v-if="workingUser.email" icon="save" @click="saveEmail">Save</mdb-btn>
        <mdb-btn icon="ban" @click="showEditModal=false">Cancel</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal v-if="showAttributes" @close="showAttributes=false">
      <mdb-modal-header class="secondary-color"><h4>Login Attributes</h4></mdb-modal-header>
      <mdb-modal-body class="text-left">
        <pre>{{ loginAttributes }}</pre>
      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal v-if="showDeleteUserConfirm" @yes="doDeleteUser" @no="showDeleteUserConfirm=false"/>
    <yes-no-modal v-if="showDeleteKeyConfirm" @yes="doDeleteKey" @no="showDeleteKeyConfirm=false"/>
    <yes-no-modal v-if="showDeleteAuthConfirm" @yes="doDeleteAuth" @no="showDeleteAuthConfirm=false"/>
    <yes-no-modal v-if="showBanModal" @yes="doBanUser" @no="showBanModal=false"
                  additional-text="User will be removed from all groups & events and will no longer be able to access the platform."/>
  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTableAdvanced'
import api from '../../services/groupsPlaceApi.js'
import yesNoModal from "../common/YesNoModal";
import CustomData from "../common/CustomData";
import CustChipInput from "../common/CustChipInput";

import gpSelect from "../common/GPSelect";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbNavbar,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbView
} from 'mdbvue';

export default {
  name: 'User',
  components: {
    mdbDropdownToggle, mdbNavbarToggler, mdbNavbar, mdbDropdownMenu, mdbDropdown, mdbDropdownItem, mdbNavbarNav,
    mdbContainer, mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    mdbInput,
    mdbIcon,
    dataTable,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardImage,
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbBadge,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    yesNoModal,
    CustomData,
    gpSelect,
    CustChipInput
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    settings: function () {
      return this.$store.state.settings
    },
    workingTenant: function() {
      if (!this.workingUser) return null
      return this.workingUser.createdByTenantId
    }

  },
  data() {
    return {
      saveScroll: 0,
      actions: [
        {name: "view", label: "View Details", class: 'text-success', icon: "clipboard"},
        {name: "pm", label: "Private Message", class: 'text-secondary', icon: "envelope"}
      ],
      forceQuery: null,
      currentUser: null,
      addUserModal: false,
      workingUser: null,
      showEditModal: false,
      newUser: null,
      showModal: false,
      views: {list: true, user: false},
      historyModal: false,
      ipModal: false,
      recordModal: false,
      transactions: [],
      ipData: [],
      tenants: [],
      affiliates: [],
      newPlan: null,
      editingTransaction: {},
      deleteCandidate: null,
      showDeleteTransConfirm: false,
      showDeleteUserConfirm: false,
      showDeleteKeyConfirm: false,
      showDeleteAuthConfirm: false,
      showBanModal: false,
      addSubModal: false,
      subData: {selectedPlan: null},
      loginAttributes: null,
      showAttributes: false
    }
  },
  watch: {
    workingTenant(n) {
      this.loadAffiliates(n)
      this.workingUser.affiliateId = null
    }
  },
  mounted() {
    if (this.$route.params.action == "proxy") this.proxy()
    if (this.$route.params.id) {
      this.forceQuery = "id:" + this.$route.params.id
    }
    if (this.userDetails.isAdmin) {
      this.actions.push({name: "proxy", label: "Proxy User", class: "text-danger", icon: "user"})
      api.get("/tenant/list?max=150", {}).then(
        (results) => {
          for (let tenant of results.data.rows) {
            let row = {value: tenant.id, text: tenant.name}
            this.tenants.push(row)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })
    }
  },
  methods: {
    viewAttributes(a) {
      this.loginAttributes = JSON.stringify(JSON.parse(a), null, 2)
      this.showAttributes = true
    },
    forcedRowLoaded(row) {
      this.showUser(row)
    },
    handleRowAction(row, action) {
      if (action == "proxy") {
        this.currentUser = row
        this.proxy()
      }
      if (action == "view") {
        this.showUser(row)
      }
      if (action == "pm") {
        this.$router.push('/conversations?start=' + row.id)
      }

    },
    editDetails() {
      this.workingUser = JSON.parse(JSON.stringify(this.currentUser))
      this.showEditModal = true
    },
    createNewSubscription() {
      this.$store.dispatch("setExecuting", true)
      this.addSubModal = false
      api.post("/user/addSubscription", {id: this.currentUser.id, plan: this.subData.selectedPlan}).then(
        (results) => {
          this.$router.push("/admin/subscription/" + results.data.id + "?return=/users/" + this.currentUser.id)
        },
        (error) => {
          this.showSubModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveEmail() {
      this.$store.dispatch("setExecuting", true)
      this.showEditModal = false
      api.post("/user/adminDetails", this.workingUser).then(
        (results) => {
          this.showUser(this.currentUser)
        },
        (error) => {
          this.showEmailModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveGroups() {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/discourseGroups/" + this.currentUser.id, {groups: this.currentUser.discourseGroups.join()}).then(
        () => {
          this.$notify.success({message: "Discourse groups updated successfully.", timeOut: 3000})
        },
        (error) => {
          this.showEmailModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    addUser() {
      this.newUser = {name: "", email: ""}
      this.addUserModal = true
    },
    saveNewUser() {
      this.$store.dispatch("setExecuting", true)
      this.addUserModal = false
      api.post("/user/create", this.newUser).then(
        (results) => {
          let row = {id: results.data.id}
          this.showUser(row)
        },
        (error) => {
          this.addUserModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    customDataSaved(data) {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/customFields/" + this.currentUser.id, data).then(
        (results) => {
          this.currentUser.customData = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    resyncIdp(login) {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/resyncIdp/" + this.currentUser.id, login).then(
        (results) => {
          login.attributes = JSON.stringify(results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    manageSubscription(sub) {
      let baseUrl = "/admin/subscription/" + sub.id + "?return=/users/" + this.currentUser.id
      if (sub.tenantId == this.settings.tenantId) {
        this.$router.push(baseUrl)
      } else {
        window.open(sub.tenantUrl + baseUrl, "_blank")
      }
    },
    groupAdmin(group) {
      if (group.tenantId == this.settings.tenantId) {
        this.$router.push("/admin/group/" + group.id)
      } else {
        window.open(group.tenantUrl + "/admin/group/" + group.id, "_blank")
      }
    },
    deleteAuth(auth) {
      this.deleteCandidate = auth
      this.showDeleteAuthConfirm = true
    },
    doDeleteAuth() {
      this.showDeleteAuthConfirm = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/deleteAuth/", this.deleteCandidate).then(
        (results) => {
          let loc = this.currentUser.oauthLogins.indexOf(this.deleteCandidate)
          if (loc > -1) this.currentUser.oauthLogins.splice(loc,1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteKey(key) {
      this.deleteCandidate = key
      this.showDeleteKeyConfirm = true
    },
    doDeleteKey() {
      this.showDeleteKeyConfirm = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/deleteKey/", this.deleteCandidate).then(
        (results) => {
          let loc = this.currentUser.apiLogins.indexOf(this.deleteCandidate)
          if (loc > -1) this.currentUser.apiLogins.splice(loc,1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteUser(user) {
      this.deleteCandidate = user
      this.showDeleteUserConfirm = true
    },
    doDeleteUser() {
      this.showDeleteUserConfirm = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/deleteUser/", this.deleteCandidate).then(
        (results) => {
          this.$store.dispatch("setDataTableReload", true)
          this.toggleView("list")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doBanUser() {
      this.showBanModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/banUser/", this.currentUser).then(
        (results) => {
          this.currentUser.enabled = false
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    unBanUser() {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/unBanUser/", this.currentUser).then(
        (results) => {
          this.currentUser.enabled = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleAdmin: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/admin/" + this.currentUser.id, {isAdmin: !this.currentUser.isAdmin}).then(
        (results) => {
          this.$notify.success({message: "Done.", timeOut: 2000})
          this.currentUser.isAdmin = !this.currentUser.isAdmin
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    toggleTenantAdmin: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/tenantAdmin/" + this.currentUser.id, {tenantAdmin: !this.currentUser.tenantAdmin}).then(
        (results) => {
          this.$notify.success({message: "Done.", timeOut: 2000})
          this.currentUser.tenantAdmin = !this.currentUser.tenantAdmin
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    showHistory: function () {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/transactions/" + this.currentUser.id).then(
        (results) => {
          this.transactions = results.data
          this.historyModal = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    ipHistory: function () {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/ipHistory/" + this.currentUser.id).then(
        (results) => {
          this.ipData = results.data
          this.ipModal = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleDelete: function (u) {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/toggleDelete/", {user: u.id}).then(
        (results) => {
          this.currentUser.deleteAfter = results.data.deleteAfter
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleView(view) {
      for (const v in this.views) {
        if (view == v) this.views[v] = true
        else this.views[v] = false
      }
      if (view == "list") {
        if (this.$route.params.id) this.$router.replace("/users")
        else {
          window.scrollTo(0, this.saveScroll)
          this.saveScroll = 0
        }
      } else {
        this.saveScroll = window.scrollY
        window.scrollTo(0, 0)
      }
    },
    proxy: function () {
      if (this.currentUser || this.$route.params.action == "proxy") {
        let pu
        if (this.$route.params.action == "proxy") pu = this.$route.params.id
        else pu = this.currentUser.id
        api.get("/user/proxy/" + pu).then(
          (response) => {
            this.$store.dispatch("setUserDetails", response.data)
            this.$router.push("/")
          },
          (error) => {
            this.showModal = false
            this.$notify.error({
                                 message: "Could not execute proxy switch. " + error.response.status,
                                 timeOut: 5000,
                                 position: 'top center'
                               })
            console.log(error.response.data)
          }
        );

      }
    },
    showUser: function (row) {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/show/" + row.id, {}).then(
        (response) => {
          this.currentUser = response.data
          this.toggleView("user")
          this.loadAffiliates(this.currentUser.createdByTenantId)
        },
        (error) => {
          this.showModal = false
          this.$notify.error({
                               message: "Error retrieving user. " + error.response.status,
                               timeOut: 5000,
                               position: 'top center'
                             })
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    loadAffiliates(tenantId) {
      this.affiliates = []
      api.get("/affiliate/pickList?tenant=" + tenantId).then(
        (results) => {
          for (let affiliate of results.data) {
            let row = {value: affiliate.id, text: affiliate.name}
            this.affiliates.push(row)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        })

    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.group-name-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.material-input {
  box-sizing: content-box;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ced4da;
  border-radius: 0;
  outline: none;
  box-shadow: none;
}

.top-right-badge {
  position: absolute;
  top: 0;
  right: 0;
}
</style>

<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>


